import { ReactElement } from 'react';
import ErrorLogo from '@public/images/error.png';
import NextImage from 'next/image';

interface ErrorPageProps {
	error: string;
}

export default function ErrorPage({ error }: Readonly<ErrorPageProps>): ReactElement {
	return (
		<div className='lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16'>
			<div className='xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0'>
				<div className='relative'>
					<div className='absolute'>
						<div>
							<h1 className='my-2 text-gray-800 font-bold text-2xl'>Oops...</h1>
							<p className='my-2 text-gray-800'>{error}</p>
						</div>
					</div>
				</div>
			</div>
			<div>
				<NextImage src={ErrorLogo} alt='Error Logo' width={539} height={400} />
			</div>
		</div>
	);
}
